module.exports = __webpack_public_path__ + "static/color element-28-ea0a177a938ba7ba3ccb9feb502c24c4.png";